import type { HrTime } from '@opentelemetry/api';
/**
 * 将 HrTime 转换为纳秒数字
 * 注意：JavaScript Number 类型只能精确表示整数到 2^53，对于超过此范围的纳秒值会丢失精度
*/
export function hrTimeToNanosNumber(hrTime: HrTime): number {
  // 将秒转换为 BigInt
  const seconds = BigInt(hrTime[0]);
  // 将纳秒转换为 BigInt
  const nanos = BigInt(hrTime[1]);
  
  // 计算总纳秒数: seconds * 10^9 + nanos
  // 注意：数字后面加 'n' 表示 BigInt 字面量，或者使用 BigInt() 构造函数
  const totalNanos = (seconds * 1_000_000_000n) + nanos;
  
  // 将 BigInt 转换为 Number
  return Number(totalNanos);
}